(function(){
    if (window.__willowMega) return; window.__willowMega = true;
    var DEFAULT_HERO_SRC = 'https://cdn.shopify.com/s/files/1/0919/3334/4023/files/willow-shop-mega-curved.webp?v=1783863529&width=1200';
    var defaultHeroImage = null;
    var defaultHeroReady = null;
    var CAP = {
      default: ['default','The Curved Collection','Softened edges, sculptural fronts'],
      design:  ['design','Fluted & Curved','Reeded fronts, softened edges'],
      sink:    ['sink','Sink Type & Layout','Single, double, floating & offset'],
      material:['material','Solid Wood Finishes','Teak, oak, mango & birch'],
      painted: ['painted','Painted Colors','Neutrals, greens & blues'],
      wood:    ['wood','Natural Wood Tones','Light, medium & dark']
    };
    function primeDefaultHero(details){
      if (!details) return null;

      if (!defaultHeroReady){
        defaultHeroImage = new Image();
        defaultHeroImage.decoding = 'async';
        defaultHeroImage.fetchPriority = 'high';
        defaultHeroReady = new Promise(function(resolve){
          function finish(ok){
            if (ok && defaultHeroImage.decode){
              defaultHeroImage.decode().catch(function(){}).then(function(){ resolve(true); });
            } else {
              resolve(Boolean(ok));
            }
          }

          defaultHeroImage.addEventListener('load', function(){ finish(true); }, { once:true });
          defaultHeroImage.addEventListener('error', function(){ finish(false); }, { once:true });
          defaultHeroImage.src = DEFAULT_HERO_SRC;

          if (defaultHeroImage.complete && defaultHeroImage.naturalWidth) finish(true);
        });
      }

      details._willowHeroReady = defaultHeroReady;
      return defaultHeroReady;
    }
    function ensureHeroImage(hero, key){
      var image = hero.querySelector('.wmega__hl[data-k="' + key + '"]');
      if (!image) return null;

      if (!image.__wReady){
        image.__wReady = new Promise(function(resolve){
          function finish(ok){
            if (ok) image.classList.add('is-loaded');
            if (ok && image.decode){
              image.decode().catch(function(){}).then(function(){ resolve(true); });
            } else {
              resolve(Boolean(ok));
            }
          }

          if (image.complete && image.naturalWidth){
            finish(true);
            return;
          }

          image.addEventListener('load', function(){ finish(true); }, { once:true });
          image.addEventListener('error', function(){ finish(false); }, { once:true });

          if (image.dataset.src){
            image.loading = 'eager';
            image.fetchPriority = 'high';
            image.src = image.dataset.src;
            image.removeAttribute('data-src');
          }
        });
      }

      return image;
    }
    function commitHero(hero, key, d, image){
      if (!image || hero.__wkey !== key || !image.classList.contains('is-loaded')) return;

      hero.querySelectorAll('.wmega__hl').forEach(function(layer){
        layer.classList.toggle('on', layer === image);
      });

      var cap = hero.querySelector('[data-wmega-cap]');
      if (cap){
        if (hero.__wcapT) clearTimeout(hero.__wcapT);
        cap.style.opacity = 0;
        hero.__wcapT = setTimeout(function(){
          if (hero.__wkey !== key) return;
          var h = hero.querySelector('[data-cap-h]');
          var p = hero.querySelector('[data-cap-p]');
          if (h) h.textContent = d[1];
          if (p) p.textContent = d[2];
          cap.style.opacity = 1;
        }, 90);
      }
    }
    function apply(hero, key){
      var d = CAP[key] || CAP.default;
      var image = ensureHeroImage(hero, d[0]);
      if (!image) return null;

      if (hero.__wkey === key){
        if (image.classList.contains('is-loaded')) commitHero(hero, key, d, image);
        return image;
      }

      hero.__wkey = key;
      if (image.classList.contains('is-loaded')){
        commitHero(hero, key, d, image);
      } else {
        image.__wReady.then(function(ok){
          if (ok) commitHero(hero, key, d, image);
        });
      }
      return image;
    }
    function findMegaRoot(target){
      if (!target || !target.closest) return null;

      var root = target.closest('.wmega');
      if (root) return root;

      var details = target.closest('details[is="details-mega"][level="top"]');
      return details && details.querySelector('.wmega');
    }
    function primeMegaImage(e){
      var details = e.target.closest && e.target.closest('details[is="details-mega"][level="top"]');
      var summary = details && details.querySelector(':scope > summary');
      var defaultReady = null;

      /* Begin the first real image request on Shop hover, before the panel is
         visible. The rendered image then resolves from cache with no blank card. */
      if (details && summary && summary.getAttribute('aria-label') === 'Shop'){
        defaultReady = primeDefaultHero(details);
      }

      var root = findMegaRoot(e.target);
      if (!root) return;

      var hero = root.querySelector('[data-wmega-hero]');
      if (!hero) return;

      var cat = e.target.closest && e.target.closest('.wmega__cat');
      var image = apply(hero, cat ? cat.dataset.hero : 'default');
      root.__wImagePrimed = true;

      var ownerDetails = root.closest('details[is="details-mega"][level="top"]');
      if (ownerDetails && image){
        var imageReady = image.__wReady || Promise.resolve(true);
        ownerDetails._willowHeroReady = defaultReady
          ? Promise.all([defaultReady, imageReady]).then(function(result){ return result.every(Boolean); })
          : imageReady;
      }
    }
    function closeMenusForPlainItem(e){
      var item = e.target.closest && e.target.closest('.header__menu > ul > li');
      if (!item || item.querySelector(':scope > details')) return;

      /* The old dropdown owns the single delayed release. Removing the overlay
         here made it snap off while the pointer crossed an ordinary link. */
      var list = item.parentElement;
      Array.from(list.children).forEach(function(sibling){
        var details = sibling.querySelector(':scope > details[is="details-dropdown"], :scope > details[is="details-mega"]');
        if (details && details.open) details.open = false;
      });
    }
    document.addEventListener('pointerover', primeMegaImage, {passive:true});
    document.addEventListener('focusin', primeMegaImage);
    document.addEventListener('pointerover', closeMenusForPlainItem, {passive:true});
    document.addEventListener('focusin', closeMenusForPlainItem);
    document.addEventListener('mouseover', function(e){
      var cat = e.target.closest && e.target.closest('.wmega__cat'); if (!cat) return;
      var root = cat.closest('.wmega'); if (!root) return;
      var hero = root.querySelector('[data-wmega-hero]'); if (hero) apply(hero, cat.dataset.hero);
    });
    document.addEventListener('mouseout', function(e){
      var cats = e.target.closest && e.target.closest('[data-wmega-cats]'); if (!cats) return;
      if (cats.contains(e.relatedTarget)) return;
      var root = cats.closest('.wmega'); if (!root) return;
      var hero = root.querySelector('[data-wmega-hero]'); if (hero) apply(hero, 'default');
    });
    /* Keep the editorial hero stable. The previous pointer parallax measured layout and
       rewrote transforms during mousemove while the blurred mega panel was animating. */
    // Force only the asynchronously injected Willow mega menu to fill its row.
    function wForce(scope){
      var root = scope && scope.querySelectorAll ? scope : document;
      var found = false;
      root.querySelectorAll('.wmega').forEach(function(w){
        found = true;
        var li = w.closest('.willow-mega-li');
        if (li){ li.style.flex='1 1 100%'; li.style.width='100%'; li.style.maxWidth='100%'; li.style.display='block'; li.style.transform='none'; li.style.opacity='1'; }
        var topDetails = w.closest('details[is="details-mega"][level="top"]');
        if (topDetails && !w.__wImagePrimed && topDetails.matches(':hover, :focus-within')){
          var hero = w.querySelector('[data-wmega-hero]');
          var image = hero && apply(hero, 'default');
          w.__wImagePrimed = true;
          if (image) topDetails._willowHeroReady = image.__wReady || Promise.resolve(true);
        }
        var list = w.closest('.mega-menu__list'); if (list){ list.style.width='100%'; list.style.maxWidth='100%'; list.style.display='block'; }
        w.style.width='min(1620px, 95vw)'; w.style.marginLeft='auto'; w.style.marginRight='auto';
      });
      return found;
    }
    var wHeaderRoot = null;
    var wmo = new MutationObserver(function(){
      if (wHeaderRoot && wHeaderRoot.isConnected) wForce(wHeaderRoot);
    });
    function wObserveHeader(root){
      wmo.disconnect();
      wHeaderRoot = root || null;
      if (!wHeaderRoot) return;
      wHeaderRoot.querySelectorAll('.mega-menu').forEach(function(menu){
        wmo.observe(menu, {childList:true, subtree:true});
      });
      wForce(wHeaderRoot);
    }
    document.addEventListener('shopify:section:load', function(e){
      if (e.target && e.target.classList && e.target.classList.contains('header-section')) wObserveHeader(e.target);
    });
    document.addEventListener('shopify:section:unload', function(e){
      if (e.target && e.target.classList && e.target.classList.contains('header-section')) wObserveHeader(null);
    });
    document.addEventListener('mouseover', function(e){
      var menu = e.target.closest && e.target.closest('.mega-menu');
      if (menu) wForce(menu);
    });
    wObserveHeader(document.querySelector('.header-section'));
  })();
